import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input
} from '@angular/core';
import * as rolesUtils from '@app/role.utils';

@Component({
  selector: 'app-tab-buttons',
  templateUrl: './tab-buttons.component.html',
  styleUrls: ['./tab-buttons.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabButtonsComponent implements OnInit {
  @Input()
  me;

  @Input()
  follow;

  constructor() { }

  ngOnInit() { }

  get followId() {
    return this.follow && this.follow.id;
  }

  get isPlanner() {
    return this.me && this.me.role && rolesUtils.isPlanner(this.me.role);
  }

  get isRegionalBuyer() {
    return this.me && this.me.role === 'regional-buyer';
  }

  get isCountryBuyer() {
    return this.me && this.me.role && rolesUtils.isCountryUser(this.me.role);
  }

  get isDesigner() {
    return this.me && this.me.role === 'designer';
  }

  get countryId() {
    return this.isCountryBuyer && this.me.CountryId;
  }

  get role() {
    return this.me && this.me.role;
  }
}
